const DATABASE = 'kapitalia-offline';
const STORE = 'saves';
export const SAVE_VERSION = 1;

export function assertSaveWritable(current, next, expected) {
  const conflict = () => {
    const error = new Error('Сохранение изменилось в другой вкладке. Загрузите актуальную партию.');
    error.code = 'SAVE_CONFLICT';
    throw error;
  };
  if (expected !== undefined && JSON.stringify(migrateSave(current)) !== JSON.stringify(migrateSave(expected))) conflict();
  if (!current) return;
  if (current.game?.id !== next.game?.id && expected === undefined) conflict();
  if (current.game?.id === next.game?.id && Number(next.game.revision) < Number(current.game.revision)) conflict();
}

export function migrateSave(save) {
  if (!save) return null;
  if (save.schemaVersion === 0 && save.game) save = { ...save, schemaVersion: 1, viewerId: save.viewerId ?? save.game.players.find((player) => !player.isBot)?.id, handoff: null };
  if (save.schemaVersion !== SAVE_VERSION || !['bots', 'hotseat'].includes(save.mode) || !Array.isArray(save.game?.players)) {
    throw new Error('Формат сохранения не поддерживается. Сохранение не удалено.');
  }
  return save;
}

export class OfflineSaveStore {
  async open() {
    return new Promise((resolve, reject) => {
      const request = indexedDB.open(DATABASE, 1);
      request.onupgradeneeded = () => request.result.createObjectStore(STORE);
      request.onsuccess = () => resolve(request.result);
      request.onerror = () => reject(new Error('Не удалось открыть локальное хранилище.'));
    });
  }

  async read() {
    const db = await this.open();
    try {
      return await new Promise((resolve, reject) => {
        const request = db.transaction(STORE).objectStore(STORE).get('current');
        request.onsuccess = () => { try { resolve(migrateSave(request.result)); } catch (error) { reject(error); } };
        request.onerror = () => reject(new Error('Не удалось прочитать сохранение.'));
      });
    } finally { db.close(); }
  }

  async write(save, { expected } = {}) {
    const db = await this.open();
    try {
      await new Promise((resolve, reject) => {
        const transaction = db.transaction(STORE, 'readwrite');
        const store = transaction.objectStore(STORE);
        let failure = null;
        const request = store.get('current');
        request.onsuccess = () => {
          try {
            assertSaveWritable(request.result ?? null, save, expected);
            store.put(save, 'current');
          } catch (error) {
            failure = error;
            transaction.abort();
          }
        };
        transaction.oncomplete = resolve;
        transaction.onabort = transaction.onerror = () => reject(failure ?? new Error('Игра не сохранена. Проверьте свободное место на устройстве.'));
      });
    } finally { db.close(); }
  }
}
